import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../WelcomePage.module.css";
import { Reveal, Stagger, StaggerItem } from "../../../../components/motion";
import { SPRING } from "../../../../utils/motion";

/**
 * @param {object} props
 * @param {object} props.section
 * @param {object} props.reveal
 * @param {function} props.sectionReveal
 */
const LandingFeatures = ({ section, reveal, sectionReveal }) => (
  <section
    ref={reveal.ref}
    className={`${styles.sectionGlow} ${sectionReveal(reveal)}`}
  >
    <div className={styles.sectionInner}>
      <Reveal className={styles.sectionCopyCenter}>
        <h2 className={styles.sectionTitle}>{section.title}</h2>
        {section.subtitle?.trim() && (
          <p className={styles.sectionSubtitle}>{section.subtitle}</p>
        )}
      </Reveal>
      <Stagger className={styles.featuresGrid}>
        {section.items.map((item) => (
          <StaggerItem
            key={item.sort_order}
            className={styles.featureCard}
            whileHover={{ y: -4 }}
            transition={SPRING.snappy}
          >
            <div className={styles.featureIcon} aria-hidden>
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <h3 className={styles.featureTitle}>{item.title}</h3>
            <p className={styles.featureDesc}>{item.description}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);

export default LandingFeatures;
